import Swiper, { Navigation } from 'swiper';

export const featureSwiper = () => {

  if( !$('.news-swiper').length ) return;

  const circleSvg = (className) => `<svg class="${
    className ? className : ''
  }" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
  <circle cx="18" cy="18" r="18"/>
  </svg>`;

  $('.news-swiper')
    .addClass('swiper')
    .find('ul')
    .addClass('swiper-wrapper')
    .children()
    .addClass('swiper-slide');

  //pagination setup
  $('.news-swiper').append('<div class="swiper-pagination">');

  const swiper = new Swiper('.news-swiper', {
    allowTouchMove: false,
    effect: 'fade',
    loop: false,
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 64,
    speed: 500,
    fadeEffect: {
      crossFade: true
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return `<div class="${className}"><div class="number"><span>0${
          index + 1
        }</span>${circleSvg('bg')}${circleSvg('fg')}</div></div>`;
      },
    },
  });

  const slides = document.querySelectorAll('.swiper-pagination-bullet');
  const swiperWrapper = document.querySelector('.swiper-wrapper');
  const progressBars = document.querySelectorAll('.number .fg');

  if (progressBars.length) {
    const path = progressBars[0].querySelector('circle');
    // const l = path.getTotalLength();
    const l = 2 * Math.PI * path.getAttribute('r');

    for (const progress of progressBars) {
      $(progress).attr('stroke-dasharray', l);
      $(progress).attr('style', `--offset: ${l}`);
      $(progress).on('animationend', onAnimationEnd);
    }
  }

  // // Retrigger Animation on Slide Change
  function onAnimationEnd() {
    const index = swiper.realIndex;
    if (swiper.realIndex < slides.length - 1) {
      swiper.slideNext();
    } else {
      // loop
      swiper.slideTo(0);
    }

    const progress = progressBars[index];

    progress.style.animation = 'none';
    void progress.offsetWidth;
    progress.style.animation = null;
  }

  // Pause Carousel/Progress Bar On Hover
  for (const [i, slide] of slides.entries()) {
    const progress = progressBars[i];

    swiperWrapper.addEventListener('mouseenter', () => {
      progress.style.animationPlayState = 'paused';
    });
    swiperWrapper.addEventListener('mouseleave', () => {
      progress.style.animationPlayState = 'running';
    });

    slide.addEventListener('mouseenter', () => {
      progress.style.animationPlayState = 'paused';
    });
    slide.addEventListener('mouseleave', () => {
      progress.style.animationPlayState = 'running';
    });
  }


};
